import tryCreateEntityItem from './tryCreateEntityItem';
import Entity from '../../schema/Entity';

/**
 * populate the entities in the store
 */
export default function populateEntities(
    entitiesBlob: any,
    isInvoiceEnabled?: boolean,
    isServiceReservationEnabled?: boolean,
    useEntityId?: boolean,
    isValidDate?: (dateTime: string, isUtcTime: boolean, entity?: Entity) => boolean
) {
    let entities: { [entityId: string]: Entity } = {};
    let entitiesArray: Entity[] = [];
    if (entitiesBlob) {
        entitiesBlob.forEach(entityItem => {
            let newEntity: Entity = tryCreateEntityItem(
                entityItem,
                isInvoiceEnabled,
                isServiceReservationEnabled,
                useEntityId,
                isValidDate
            );
            if (newEntity) {
                entities[newEntity.id] = newEntity;
                entitiesArray.push(newEntity);
            } else {
                return null;
            }
        });
    }

    if (Object.keys(entities).length == 0) {
        return null;
    }
    return {
        entitiesDictionary: entities,
        entitiesArray: entitiesArray,
    };
}
